import { Routes } from '@angular/router';
import { AuthGuardService, SessionInfoResolver } from '@se/platform';
import { DicomLandingPage } from './toolupload/dicom/pages/landing-page/landing-page.component';
import { TooluploadFormComponent } from './toolupload/toolupload-form/toolupload-form.component';
import { TooluploadToolbarComponent } from './toolupload/toolupload-toolbar/toolupload-toolbar.component';

export const routes: Routes = [
    {
        path: 'upload',
        canActivate: [AuthGuardService],
        resolve: {
            sessionInfo: SessionInfoResolver,
        },
        children: [
            { path: '', component: TooluploadFormComponent },
            { path: '', outlet: 'vnextToolbar', component: TooluploadToolbarComponent },
        ],
    },
    {
        path: 'upload-dicom',
        canActivate: [AuthGuardService],
        resolve: {
            sessionInfo: SessionInfoResolver,
        },
        children: [
            { path: '', component: DicomLandingPage },
            { path: '', outlet: 'vnextToolbar', component: TooluploadToolbarComponent },
        ],
    },
    
];
